import { KeyValuePair } from '@core/models/dyna.model';

export interface TableConfig {
  apiData: [];
  isServerPagination: boolean;
  isFilterable?: boolean;
  isAdd?: boolean;
  columnMapping: ColumnMapping[];
  actionMapping: ActionMapping[];
  subTableDataKey?: string;
  subTables?: TableConfig[];
}

export interface ActionMapping {
  class: string;
  index: number;
  icon: string;
  event: string;
}

export interface ColumnMapping {
  index: number;
  key: string;
  label: string;
  type: string;
  options?: KeyValuePair[];
  optionsTransfer?: OptionsTransfer;
}

export interface ActionRequest {
  event: string;
  data: any;
}

export enum ViewType {
  Text = 'text',
  Serial = 'serial',
  Date = 'date',
  Number = 'number',
  Boolean = 'boolean',
  DateTime = 'datetime',

  Email = 'email',
  Select = 'select',
  Upload = 'upload',
  Password = 'password',
  ListSelect = 'ListSelect',

  SubForm = 'subform',
  SubTable = 'subtable',
  GroupLabel = 'grouplabel',
  DayList = 'daylist',
}

export enum ActionEvent {
	Edit = 'edit',
	Delete = 'delete',
	Save = 'save',
	Clear = 'clear',
	Reset = 'reset',
	Cancel = 'cancel',
  Visibility = 'visibility',

	AddSub = 'addSub',
	RemoveSub = 'removeSub',

}

export enum ValidatorNames {
  Required = 'required',
  Email = 'email',
}

export interface FormConfig {
  formData: {};
  fieldMapping: FieldMapping[];
  actionMapping: ActionMapping[];
  subFormDataKey?: string;
  subForms?: FormConfig[];
}

export interface FieldMapping {
  index: number;
  key: string;
  label: string;
  type: string;
  isHidden?: boolean;
  options?: KeyValuePair[] | any[];
  validation?: FieldValidation[];
  fileType?: string;
  isMultiple?: boolean;
  optionsTransfer?: OptionsTransfer;
}

export interface FieldValidation {
  type?: string;
  message?: string;
}

export interface PageConfig {
  pageTitle: string;
  apiUrl?: string;
  stopDefaultGet?: boolean;
  tableConfig?: TableConfig;
  formConfig?: FormConfig;
}

export const FormFields = { Id: 'id' };

export interface OptionsTransfer {
  keyGroup?: string;
  table?: string;
  key?: string;
  value?: string;
  storeId?: boolean;
  options?: KeyValuePair[];

  cascadeBy?: string;
  cascadeValue?: string;
}


export const TableDefaultActions = [
	{ event: ActionEvent.Edit, icon: "mdi mdi-square-edit-outline", class: "btn-outline-success", index: 1 },
	{ event: ActionEvent.Delete, icon: "mdi mdi-trash-can-outline", class: "btn-outline-danger", index: 2 }
];

export const FormDefaultActions = [
	{ event: ActionEvent.Reset, icon: "mdi mdi-backspace", class: "btn-outline-warning", index: 1 },
	{ event: ActionEvent.Cancel, icon: "mdi mdi-cancel", class: "btn-outline-danger", index: 2 },
	{ event: ActionEvent.Save, icon: "mdi mdi-content-save-all", class: "btn-outline-success", index: 3 }
];
